
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire03e2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire03e2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $8eOUE = parcelRequire("8eOUE");

var $g8FP8 = parcelRequire("g8FP8");
/**
 * All admin specific functionality including (but not limited to):
 * - Importing & initialising ./pocketbase.ts
 * - Setting up collections
 * - Creating/deleting/setting passwords for users
 */ const $f2f6ad3fe9c1221f$var$pb = (0, $8eOUE.init)({});
const $f2f6ad3fe9c1221f$var$ALLOW_ONLY_REGISTERED_USERS = '@request.auth.id != ""'; // https://pocketbase.io/docs/api-rules-and-filters#examples
const $f2f6ad3fe9c1221f$var$ALLOW_IF_SELF = "id = @request.auth.id";
const $f2f6ad3fe9c1221f$var$ALLOW_ONLY_ADMINS = null; // null sets admin only
const $f2f6ad3fe9c1221f$var$ALLOW_EVERYONE = ""; // empty allows everyone, no matter if logged in
const $f2f6ad3fe9c1221f$var$ALLOW_ONLY_CHAPERONE_AND_ADMINS = `@request.auth.is_chaperone = true`;
const $f2f6ad3fe9c1221f$var$ALLOW_IF_IS_CHAPERONE_IS_NOT_SET = "@request.data.is_chaperone:isset = false";
const $f2f6ad3fe9c1221f$var$ALLOW_IF_NOT_ATTENDEE = 'username != "attendee"';
const $f2f6ad3fe9c1221f$var$ALLOW_IF_CHAPERONE_IS_REQUESTER = `@request.auth.id = chaperone`;
async function $f2f6ad3fe9c1221f$var$createOrUpdateCollection(collectionId, schema) {
    let data = null;
    let action = "";
    try {
        await $f2f6ad3fe9c1221f$var$pb.collections.getOne(collectionId); // Will throw to catch if not found
        data = await $f2f6ad3fe9c1221f$var$pb.collections.update(collectionId, schema);
        action = "Updated";
    } catch (err) {
        if (err.status == 404) {
            (0, $g8FP8.warning)(collectionId + " not found, creating...");
            data = await $f2f6ad3fe9c1221f$var$pb.collections.create(schema);
            action = "Created";
        }
    }
    if (data) (0, $g8FP8.success)(`${action} collection ${data.name}! (ID: ${data.id}`);
}
async function $f2f6ad3fe9c1221f$var$setupCollections() {
    const requirePINForViewingSlogans = $("#require-login").is(":checked");
    const sloganViewOrListPermission = requirePINForViewingSlogans ? $f2f6ad3fe9c1221f$var$ALLOW_ONLY_REGISTERED_USERS : $f2f6ad3fe9c1221f$var$ALLOW_EVERYONE;
    try {
        // COLLECTION: users
        const data = await $f2f6ad3fe9c1221f$var$pb.collections.update("users", {
            schema: [
                {
                    name: "is_chaperone",
                    type: "bool"
                }
            ],
            listRule: `${$f2f6ad3fe9c1221f$var$ALLOW_IF_SELF} || username ~ "chaperone%"`,
            createRule: $f2f6ad3fe9c1221f$var$ALLOW_ONLY_ADMINS,
            updateRule: `${$f2f6ad3fe9c1221f$var$ALLOW_IF_NOT_ATTENDEE} && ${$f2f6ad3fe9c1221f$var$ALLOW_IF_SELF} && ${$f2f6ad3fe9c1221f$var$ALLOW_IF_IS_CHAPERONE_IS_NOT_SET}`,
            deleteRule: $f2f6ad3fe9c1221f$var$ALLOW_ONLY_ADMINS,
            options: {
                allowOAuth2Auth: false,
                allowEmailAuth: false,
                requireEmail: false,
                minPasswordLength: 5
            }
        });
        (0, $g8FP8.success)(`Setup permission for collection ${data.name}! (ID: ${data.id})`);
    } catch (err) {
        (0, $g8FP8.reportError)("Error while trying to update users collection", err);
    }
    // Setting up collections clears slogan values. Save them here
    let slogans;
    try {
        slogans = await $f2f6ad3fe9c1221f$var$pb.collection("slogans").getFullList();
    } catch (err) {
        slogans = [];
        (0, $g8FP8.reportError)("Error while trying to get existing slogan values", err);
    }
    try {
        // COLLECTION: slogans
        await $f2f6ad3fe9c1221f$var$createOrUpdateCollection("slogans", {
            name: "slogans",
            type: "base",
            schema: [
                {
                    name: "text",
                    type: "text",
                    required: true
                }
            ],
            listRule: sloganViewOrListPermission,
            viewRule: sloganViewOrListPermission,
            createRule: $f2f6ad3fe9c1221f$var$ALLOW_ONLY_CHAPERONE_AND_ADMINS,
            updateRule: $f2f6ad3fe9c1221f$var$ALLOW_ONLY_CHAPERONE_AND_ADMINS,
            deleteRule: $f2f6ad3fe9c1221f$var$ALLOW_ONLY_CHAPERONE_AND_ADMINS
        });
    } catch (err) {
        (0, $g8FP8.reportError)("Error while trying to create/update slogans collection", err);
    }
    // Re-add slogan values
    try {
        if (slogans.length > 0) {
            slogans.forEach(async (slogan)=>{
                await $f2f6ad3fe9c1221f$var$pb.collection("slogans").update(slogan.id, {
                    text: slogan.text
                });
            });
            (0, $g8FP8.success)("Re-added slogan values");
        }
    } catch (err) {
        (0, $g8FP8.reportError)("Error while trying to re-add slogan values", err);
    }
    try {
        // COLLECTION: ping
        const slogansCollectionId = (await $f2f6ad3fe9c1221f$var$pb.collections.getOne("slogans")).id;
        const usersCollectionId = (await $f2f6ad3fe9c1221f$var$pb.collections.getOne("users")).id;
        await $f2f6ad3fe9c1221f$var$createOrUpdateCollection("ping", {
            name: "ping",
            type: "base",
            schema: [
                {
                    name: "message",
                    type: "text",
                    required: false
                },
                {
                    name: "currentslogan",
                    type: "relation",
                    options: {
                        collectionId: slogansCollectionId,
                        maxSelect: 1,
                        cascadeDelete: false
                    }
                },
                {
                    name: "chaperone",
                    type: "relation",
                    options: {
                        collectionId: usersCollectionId,
                        maxSelect: 1,
                        cascadeDelete: false
                    }
                },
                {
                    name: "chaperone_nickname",
                    type: "text"
                }
            ],
            listRule: sloganViewOrListPermission,
            viewRule: sloganViewOrListPermission,
            createRule: $f2f6ad3fe9c1221f$var$ALLOW_ONLY_CHAPERONE_AND_ADMINS,
            updateRule: $f2f6ad3fe9c1221f$var$ALLOW_IF_CHAPERONE_IS_REQUESTER,
            deleteRule: $f2f6ad3fe9c1221f$var$ALLOW_ONLY_ADMINS
        });
    } catch (err) {
        (0, $g8FP8.reportError)("Error while creating/updating ping collection", err);
    }
    try {
        // Cleanup any old ping items
        const allItems = await $f2f6ad3fe9c1221f$var$pb.collection("ping").getFullList();
        allItems.forEach(async (item)=>await $f2f6ad3fe9c1221f$var$pb.collection("ping").delete(item.id));
        // Create empty ping item
        await $f2f6ad3fe9c1221f$var$pb.collection("ping").create({
            message: "",
            currentslogan: []
        });
    } catch (err) {
        (0, $g8FP8.reportError)("Error while cleaning up old pings", err);
    }
}
async function $f2f6ad3fe9c1221f$var$createUserOnForm(e) {
    e.preventDefault();
    const form = $(e.target);
    const username = form.attr("id");
    function password() {
        return form.children(".password").val();
    }
    function passwordConfirm() {
        return form.children(".passwordConfirm").val();
    }
    if (!username) {
        (0, $g8FP8.error)("Username is missing when creating user");
        throw Error(e);
    }
    if (username != "chaperone") $f2f6ad3fe9c1221f$var$createUser(username, false, password, passwordConfirm);
    else {
        // Remove any existing chaperones
        const chaperones = await $f2f6ad3fe9c1221f$var$pb.collection("users").getFullList({
            filter: "is_chaperone = true"
        });
        chaperones.forEach(async (user)=>{
            await $f2f6ad3fe9c1221f$var$pb.collection("users").delete(user.id);
            (0, $g8FP8.info)(`Deleted ${user.username} (id: ${user.id})`);
        });
        const amountRaw = form.children("input[name='chaperone-amount']").val();
        let amount;
        if (!amountRaw) (0, $g8FP8.error)("Amount of chaperone accounts must be set");
        try {
            amount = parseInt(amountRaw);
        } catch (e) {
            (0, $g8FP8.error)("Failed to parse chaperone amount. See console.log");
            throw new Error(e);
        }
        for(let i = 0; i < amount; i++)console.log(await $f2f6ad3fe9c1221f$var$createUser(`${username}${i}`, true, password, passwordConfirm));
    }
}
// Keep the passwords outside of variables
async function $f2f6ad3fe9c1221f$var$createUser(username, is_chaperone, password, passwordConfirm) {
    function newUser() {
        return {
            username: username,
            is_chaperone: is_chaperone,
            password: password(),
            passwordConfirm: passwordConfirm()
        };
    }
    const users = await $f2f6ad3fe9c1221f$var$pb.collection("users").getFullList();
    const existingUser = users.find((user)=>user.username == username);
    try {
        let user;
        if (existingUser) user = await $f2f6ad3fe9c1221f$var$pb.collection("users").update(existingUser.id, newUser(), {
            requestKey: null
        });
        else user = await $f2f6ad3fe9c1221f$var$pb.collection("users").create(newUser(), {
            requestKey: null
        });
        (0, $g8FP8.success)(`PIN set for ${user.username}!`);
        return user;
    } catch (err) {
        (0, $g8FP8.reportError)("Error while setting pin for " + username, err);
    }
}
function $f2f6ad3fe9c1221f$var$onRequireLoginChange() {
    (0, $g8FP8.warning)("Press Setup collections to save changes!");
}
$(window).on("load", async function() {
    $("#setup-collections").on("click", $f2f6ad3fe9c1221f$var$setupCollections);
    $(".userForm").on("submit", $f2f6ad3fe9c1221f$var$createUserOnForm);
    $("#require-login").on("change", $f2f6ad3fe9c1221f$var$onRequireLoginChange);
    try {
        const slogans = await $f2f6ad3fe9c1221f$var$pb.collections.getOne($f2f6ad3fe9c1221f$var$pb.collection("slogans").collectionIdOrName);
        console.log(slogans.viewRule);
        if (slogans.viewRule != $f2f6ad3fe9c1221f$var$ALLOW_EVERYONE) $("#require-login").prop("checked", true);
    } catch (err) {
        (0, $g8FP8.reportError)("Error while trying to get slogans collection", err);
    }
});


//# sourceMappingURL=admin.9ea241dd.js.map
